import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shouldReloadGrid: false,
  rowSelection: false,
};

const gridSlice = createSlice({
  name: 'grid',
  initialState,
  reducers: {
    reloadGrid: state => {
      state.shouldReloadGrid = true;
    },
    resetReloadGrid: state => {
      state.shouldReloadGrid = false;
    },
    rowSelectionDisable: state => {
      state.rowSelection = false;
    },
    rowSelectionEnable: state => {
      state.rowSelection = true;
    },
  },
});

export const {
  reloadGrid,
  resetReloadGrid,
  rowSelectionEnable,
  rowSelectionDisable,
} = gridSlice.actions;
export default gridSlice.reducer;
